import ServiceNoticeIcon from "../../../assets/svg/icon_service_notice.svg";
import CollectIcon from "../../../assets/svg/icon_collect.svg";
import { StyleProp, ViewStyle,View } from "react-native";
import { SystemTopic } from "../CListItem";
export const ServiceIcon = ({ size, uid,style }: { size?: number; uid: number,style?: StyleProp<ViewStyle> }) => {
  const height = size ? size : 45;
  const width = size ? size : 45;
  return (
    <View style={style}>
      {uid === SystemTopic.Assistant && (
        <ServiceNoticeIcon height={height} width={width} />
      )}
      {uid === SystemTopic.Collect && (
        <CollectIcon  height={height} width={width} />
      )}
      {uid === SystemTopic.Notification && (
        <ServiceNoticeIcon height={height} width={width} />
      )}
    </View>
  );
};
